module.exports = __webpack_public_path__ + "img/computer-mouse.15aa990e.svg";